@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.drop-menu {
  background-color: @dropdown-INTERNAL--background-color;
  position: fixed;

  &.top-right {
    transform: translate(-100%, -100%);
  }

  &.top-left {
    transform: translate(0, -100%);
  }

  &.bottom-right {
    transform: translate(-100%, 0);
  }
}

.drop {
  position: relative;
}

.select {
  display: inline-block;
}

.select-button {
  position: relative;
  padding: 0 30px 0 10px;
  text-align: left;
  letter-spacing: 0;
  max-width: 100%;

  &.has-label {
    height: 42px;
    padding: 5px 30px 5px 10px;
  }
}
